<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-leave-to {
  transform: scale(0.7);
  opacity: 0;
}
.slide-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: scale(1.3);
  opacity: 0;
}
</style>
<template>
  <div>
    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary">
        <v-card-text>
          Aguarde...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-app id="inspire">
      <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
        expand-on-hover
      >
        <v-list dense>
          <template>
            <v-list-item link to="/">
              <v-list-item-action>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <ScopeProvider scope="products.read">
              <v-list-item link :to="{ name: 'products' }">
                <v-list-item-action>
                  <v-icon>mdi-cart</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Produtos</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </ScopeProvider>
            <ScopeProvider scope="products.categories.read">
              <v-list-item link :to="{ name: 'categories' }">
                <v-list-item-action>
                  <v-icon>mdi-shape</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Categorias</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </ScopeProvider>
            <v-list-item link to="/brand">
              <v-list-item-action>
                <v-icon>mdi-briefcase</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Marcas</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link to="/product_prices">
              <v-list-item-action>
                <v-icon>mdi-cart</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Preço dos Produtos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
        <template v-slot:append>
          <v-list>
            <v-list-item link to="/logout">
              <v-list-item-action>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
      </v-navigation-drawer>
      <v-progress-linear
        indeterminate
        color="yellow darken-2"
      ></v-progress-linear>
      <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        elevation="5"
        color="primary"
        dark
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
          <h1>
            <v-img src="@/assets/logo.png" width="170px"></v-img>
          </h1>
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon>
          <v-icon>mdi-bell</v-icon>
        </v-btn>
        <v-menu :close-on-content-click="true" bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon large>
              <v-avatar color="secondary" size="40">
                <v-img
                  v-if="user.avatar"
                  :src="user.avatar"
                  :alt="user.name"
                  class="avatar"
                />
                <span v-else class="white--text">{{ user.name[0] }}</span>
              </v-avatar>
            </v-btn>
          </template>
          <v-card>
            <v-list dense>
              <v-list-item>
                <v-list-item-avatar class="mr-2">
                  <v-avatar color="primary" size="50">
                    <v-img
                      v-if="user.avatar"
                      :src="user.avatar"
                      :alt="user.name"
                      class="avatar"
                    />
                    <span v-else class="white--text">{{ user.name[0] }}</span>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ user.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-item to="/logout">
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-app-bar>
      <v-main id="app_content">
        <transition name="slide-fade">
          <router-view></router-view>
        </transition>
      </v-main>
      <v-snackbar
        v-model="snackbar.active"
        :timeout="5000"
        left
        bottom
        :color="snackbar.color || ''"
      >
        {{ snackbar.text }}
        <!-- <v-btn color="white" text @click="closeSnack">Fechar</v-btn> -->
      </v-snackbar>
    </v-app>
  </div>
</template>

<script>
import ScopeProvider from "../components/ScopeProvider";

export default {
  name: "HelloWorld",
  components: {
    ScopeProvider,
  },
  data: () => ({
    dialog: false,
    drawer: null,
    items: [
      { icon: "mdi-view-dashboard", text: "Dashboard", link: "/" },
      {
        icon: "mdi-account-group",
        text: "Usuários",
        link: "/users",
        admin: true,
      },
    ],
  }),
  methods: {
    closeSnack() {
      this.$store.commit("closeMessage");
    },
  },
  computed: {
    loading() {
      return this.$store.getters.getLoading;
    },
    user() {
      return this.$store.getters["auth/getUser"];
    },
    snackbar() {
      return this.$store.getters.getSnackbar;
    },
  },
};
</script>
